import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  Bar,
  BarChart,
  Brush,
  LabelList,
  Legend,
  ResponsiveContainer,
  Tooltip,
  XAxis,
} from 'recharts';
import { IChartProps, StickyTooltip } from '../../../../../component/charts';
import ChartCard from '../../../../../component/charts/chartCard';
import {
  labelFormatterPercentile,
  labelFormatterPercentileInteger,
} from '../../../../../shared/formatters/formatters';
import { ReleasesSalesEcoMapChartData } from './types';

export const PercentileVGVECOMAP: React.FC = () => {
  const { chartsDataPrimary } = useSelector(
    (state: any) => state.offersPrimaryState
  );
  const { requestStatus } = useSelector(
    (state: any) => state.offersPrimaryState
  );
  return (
    <ChartCard
      data={chartsDataPrimary['eco_map']}
      Chart={PercentileVGVECOMAPChart}
      cy={'PercentileVGVECOMAP'}
      id={'percentileVGVECOMAP'}
      requestStatus={requestStatus['launchedUnits']}
    />
  );
};

const PercentileVGVECOMAPChart: React.FC<
  IChartProps<ReleasesSalesEcoMapChartData[]>
> = ({ data, cy, id }) => {
  const [hasClicked, setHasClicked] = useState<boolean>(false);
  const [recordTooltip, setRecordTooltip] = useState<JSX.Element | null>(null);
  const [stopChange, setStopChange] = useState<boolean>(false);
  const formatterFunctions = [
    labelFormatterPercentileInteger,
    labelFormatterPercentileInteger,
  ];
  return (
    <ResponsiveContainer
      width="100%"
      height="100%"
      data-cy={`PercentileVGVECOMAP${cy}`}
    >
      <BarChart
        id={id}
        data={data}
        margin={{
          top: 20,
          right: 30,
          left: 20,
          bottom: 5,
        }}
        onClick={() => setHasClicked(!hasClicked)}
      >
        <Tooltip
          wrapperStyle={{ visibility: 'visible' }}
          content={
            <StickyTooltip
              hasClicked={hasClicked}
              recordTooltip={recordTooltip}
              setRecordTooltip={setRecordTooltip}
              stopChange={stopChange}
              setStopChange={setStopChange}
              formatterFunctions={formatterFunctions}
            />
          }
        />
        <XAxis dataKey="period" padding="gap" domain={[0, 120]} />
        <Legend iconType="circle" />
        <Bar
          isAnimationActive={false}
          dataKey="subtitle_eco_sales_percetage"
          name="ECO"
          stackId="a"
          fill="#3f205a"
        >
          <LabelList
            dataKey="subtitle_eco_sales_percetage"
            formatter={(value: number) =>
              value > 5 ? labelFormatterPercentileInteger(value) : null
            }
            fill="#FFF"
          />
        </Bar>
        <Bar
          isAnimationActive={false}
          dataKey="subtitle_map_sales_percetage"
          name="MAP"
          stackId="a"
          fill="#BA96D9"
        >
          <LabelList
            dataKey="subtitle_map_sales_percetage"
            formatter={(value: number) =>
              value > 5 ? labelFormatterPercentileInteger(value) : null
            }
          />
        </Bar>
        <Brush dataKey="period" height={30} stroke="#8884d8" />
      </BarChart>
    </ResponsiveContainer>
  );
};
